import { BREAKPOINTS } from '../config.js';
import { initSlider } from './splide-sett.js';

const { mqTouch, mqTablet } = BREAKPOINTS;

const mq = window.matchMedia(`(max-width: ${mqTouch}px)`);

// const elemSplide = document.querySelector('.elem');
// if (elemSplide) {
//   initSlider(elemSplide, {
//     perPage: 2,
//     gap: '1.5rem',
//     breakpoints: {
//       [mqTouch]: {},
//       [mqTablet]: {},
//     },
//   });
// }

const lookingSplides = document.querySelectorAll('.looking__splide');
lookingSplides?.forEach(container => {
  initSlider(container, {
    perPage: 4,
    gap: '1.25rem',
    breakpoints: {
      [mqTouch]: {
        perPage: 2,
      },
      [mqTablet]: {
        perPage: 1,
      },
    },
  });
});

const insightsSplides = document.querySelectorAll('.insights__splide');
insightsSplides?.forEach(container => {
  initSlider(container, {
    perPage: 3,
    gap: '1.5rem',
    pagination: false,

    breakpoints: {
      [mqTouch]: {
        pagination: true,
        perPage: 2,
        gap: '1rem',
      },
      [mqTablet]: {
        perPage: 1,
      },
    },
  });
});

const embdSplides = document.querySelectorAll('.embd-slider');
embdSplides?.forEach(container => {
  initSlider(container, {
    type: 'fade',
    updateOnMove: false,
    rewind: true,
  });
});

// let elemSliderInstance;
// const elem = document.querySelector('.elem');

// const elemInitSlider = () => {
//   if (elem && !elemSliderInstance) {
//     elemSliderInstance = initSlider(elem, {
//       perPage: 2,
//       gap: '1.5rem',
//       arrows: false,
//       breakpoints: {
//         [mqTouch]: {
//           arrows: true,
//         },
//         [mqTablet]: {},
//       },
//     });
//   }
// };

let baseSliderInstances = [];
const base = document.querySelectorAll('.splide__base');

const baseInitSliders = () => {
  if (base && !baseSliderInstances.length) {
    base.forEach(container => {
      const slider = initSlider(container, {
        perPage: 2,
        gap: '1rem',
        breakpoints: {
          [mqTablet]: {
            perPage: 1,
          },
        },
      });
      baseSliderInstances.push(slider);
    });
  }
};

const destroySliders = () => {
  if (baseSliderInstances) {
    baseSliderInstances.forEach(instance => {
      instance.destroy();
    });
    baseSliderInstances = [];
  }
  // if (elemSliderInstance) {
  //   elemSliderInstance.destroy();
  //   elemSliderInstance = null;
  // }
};

function checkViewport() {
  baseInitSliders();
  // elemInitSlider();

  if (!mq.matches) {
    destroySliders();
  }
}

mq.addEventListener('change', checkViewport);
document.addEventListener('DOMContentLoaded', checkViewport);
